// 用户信息仓库
const userinfo = {
  state: {  ////用户的公共变量仓库  ///使用 this.$store.state.userinfo(子模组，没有时不写).userId（用户变量）
    userId:'',
  },
  mutations: {  ///同步提交信息的方法，组件中的使用 this.$store.commit('updataUserId（定义的方法名）' , '传入的参数')
    updataUserId(state,userId){
      state.userId = userId;
    }
  },
  actions: {   ////使用方法：this.$store.dispatch('asyUpdataUserId',this.registerSubmitData.telePhone); ///异步提交用户的账号信息到仓库
    asyUpdataUserId(context,userId){
        context.commit('updataUserId',userId);
      }
  },
  modules: {
    
  }
}

export default userinfo